import { AmazonConnectCcpLauncher } from '@montugroup/clinic-telecom';
import { FF_C4C_IMMEDIATE_NURSE_CONSULTATION_V2, FF_C4C_VOICE_CALL } from '../../constants/featureFlags';
import { useFeatureFlags } from '../../hooks/flags/useFeatureFlags';

export type AmazonConnectProps = {
  isEnabled: boolean;
};

// TODO: [B2C-8488] Remove immediate nurse consultation logic
export const AmazonConnect = ({ isEnabled }: AmazonConnectProps) => {
  const { flags } = useFeatureFlags();
  const isVoiceCallEnabled = flags[FF_C4C_VOICE_CALL];
  const isImmediateNurseConsultationV2Enabled = flags[FF_C4C_IMMEDIATE_NURSE_CONSULTATION_V2];

  // Only render if all conditions are met, including the feature flag that controls the provider
  if (!isImmediateNurseConsultationV2Enabled || !isVoiceCallEnabled || !isEnabled) {
    return null;
  }

  return <AmazonConnectCcpLauncher />;
};
